import PropTypes from 'prop-types';
import React from 'react';

export const UnderlyingPriceTrailWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'UNDERLYING_PRICE_TRAIL',
    category: 'Exit',
    type: 'Underlying Price Trail',
    domain: 'Underlying',
  };
  const amount = softOrder.amount;
  const priceToBreak = softOrder.priceToBreak;

  return <Component details={details} amount={amount} priceToBreak={priceToBreak} {...rest}/>;
};

UnderlyingPriceTrailWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    amount: PropTypes.any,
    priceToBreak: PropTypes.any
  })
};


